<template>
  <header class="mc-main-header cfa">
    <div class="lfp hf">
      <div class="mc-logo ftp">
        <div class="mc-logo-large">
          <img src="/static/images/pic-logo.png">
        </div>
        <div class="mc-logo-small">
          <img src="/static/images/pic-logo-s.png">
        </div>
      </div>
      <div class="mc-tool-bar ftp hf">
        <div class="item ftp mc-sidebar-toggle-btn" @click="toggleSidebar">
          <i class="fa fa-bars"></i>
        </div>
      </div>
      <div class="mc-top-nav ftp hf">
        <div class="item ftp" :class="{ active: activeNavIdx === i }" v-for="(item, i) in config.navGroup" :key="i" @click="changeNav(item.href)">{{item.label}}</div>
      </div>
    </div>
    <div class="mc-nav-bar rfp hf">
      <div class="mc-user-info ftp">
        <div class="mc-user-name">{{memberInfo.AuName}}</div>
        <div class="mc-pop-menu field-box">
          <div class="mc-btn" @click.stop="loginOut">Login Out</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import config from '@/components/common/config'
import user from '@/components/common/user'
// import tools from '@/components/common/tools'

export default {
  props: {
    activeNavIdx: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      config: config
    }
  },
  computed: {
    memberInfo() {
      return this.$store.state.user.memberInfo
    }
  },
  methods: {
    // 顶部导航点击
    changeNav(url) {
      this.$router.push(url)
    },
    // 侧栏展开收拢
    toggleSidebar() {
      this.$emit('toggleSideBar')
    },
    loginOut() {
      user.loginOut()
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/lib-mixin';
</style>



// WEBPACK FOOTER //
// TopBar.vue?1f1a5a4c